var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 11.6C18.4 10.7 19 9.4 19 8C19 5.2 16.8 3 14 3H6C5.4 3 5 3.4 5 4V20C5 20.6 5.4 21 6 21H15C17.8 21 20 18.8 20 16C20 14.1 18.9 12.5 17.4 11.6ZM7 5H14C15.7 5 17 6.3 17 8C17 9.7 15.7 11 14 11H7V5ZM15 19H7V13H15C16.7 13 18 14.3 18 16C18 17.7 16.7 19 15 19Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconBold.893ac8f12203a5b7f4e1c8f8b83bf234.svg";